import type {
  PosLayout,
  PosLayoutResponse,
  PosLayoutSaveResponse,
} from '@/api/types'
import { apiRequest } from '@/api/client'

export const posLayoutsApi = {
  get: (restaurantId: number) =>
    apiRequest<PosLayoutResponse>(`/api/v0/admin/pos-layouts/${restaurantId}`),
  save: (restaurantId: number, layout: PosLayout) =>
    apiRequest<PosLayoutSaveResponse>(
      `/api/v0/admin/pos-layouts/${restaurantId}`,
      {
        method: 'PUT',
        body: JSON.stringify(layout),
      },
    ),
}
